import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import AttachedItem from './attachedItem';

import noAttachmentIcon from '../../../../../assets/svg/attachments.svg';
import deleteIcon from '../../../../../assets/svg/deleteFolderIconRed.svg';
import { AttachmentList } from '../../../../../interfaces/AttachmentObject';
import { setAttachmentsEmptyFlag } from '../../../../../slices/piiRemovalSlice';
import { RootState } from '../../../../../utils/store';

import { Text } from '~/components/ui/text';

const AttachmentTab = () => {
  const reportDetails = useSelector(
    (state: RootState) => state.reportData.report,
  );
  const removeAllAttachmentsFlag = useSelector(
    (state: RootState) => state.piiRemoval.removeAllAttachmentsFlag,
  );
  const dispatch = useDispatch();
  const WHISTLEBLOWER_TYPE = 1;
  const IS_RECORDING = 1;
  const [whistleblowerAttachments, setWistleblowerAttachments] = useState<
    AttachmentList[]
  >([]);

  useEffect(() => {
    const newAttachments: AttachmentList[] =
      reportDetails.reportAttachments.filter((attachment) =>
        attachment.files.some(
          (file) =>
            file.userType === WHISTLEBLOWER_TYPE || file.userType === null,
        ),
      );
    setWistleblowerAttachments(newAttachments);
  }, [reportDetails.reportAttachments]);

  useEffect(() => {
    dispatch(
      setAttachmentsEmptyFlag(
        whistleblowerAttachments.length === 0 ? true : false,
      ),
    );
  }, [dispatch, whistleblowerAttachments.length]);

  return (
    <div className='relative h-full'>
      <div className='h-[460px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-thumb-rounded-full p-2'>
        {whistleblowerAttachments.length === 0 && (
          <div className='relative flex flex-col h-full py-5 justify-center items-center gap-4 overflow-hidden rounded-md bg-transparent border-transparent'>
            <img
              src={noAttachmentIcon}
              alt='no-attachment-icon'
              className='w-48 h-40'
            />
            <Text className='text-neutral-500'>
              <FormattedMessage defaultMessage='No attachment files uploaded' />
            </Text>
          </div>
        )}

        {whistleblowerAttachments?.map((item, attachmentIndex) => {
          return (
            <div key={attachmentIndex}>
              {removeAllAttachmentsFlag ? (
                <>
                  <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 bg-transparent border-transparent'>
                    {item.files.map((file, key) => {
                      if (file.attachmentType === IS_RECORDING) {
                        return <></>;
                      }
                      return (
                        <div key={key} className='box-border'>
                          <AttachedItem {...file} />
                        </div>
                      );
                    })}
                  </div>
                  <div className='absolute inset-0 flex justify-center items-center rounded-[5px] bg-[rgba(0,0,0,0.3)]'>
                    <div className='w-[292px] h-[88px] bg-[rgba(255,255,255,0.8)] flex justify-center items-center rounded-[6px]'>
                      <div className='flex flex-col justify-center items-center'>
                        <img
                          src={deleteIcon}
                          alt='delete-folder-icon'
                          className='w-[32px] h-[32px]'
                        />
                        <p className='text-red-600 text-[16px] font-sans'>
                          <FormattedMessage defaultMessage='All attachments are to be removed.' />
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 bg-transparent border-transparent'>
                  {item.files.map((file, key) => {
                    if (file.attachmentType === IS_RECORDING) {
                      return <></>;
                    }
                    return (
                      <div key={key} className='box-border'>
                        <AttachedItem {...file} />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AttachmentTab;
